import posthog from "posthog-js";
import { CreateThemeType } from "../types";
import { format } from "date-fns";
import { axiosReq } from "@/lib/axios";
import { captureApiError } from "@/lib/sentry-fn";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/lib/react-query" 

export const useCreateCampaignStory = (onGenerate: (id: number) => void) => {

  const request = async ({ formData, signal }: { formData: CreateThemeType, signal: AbortSignal }): Promise<{
    data: {
      event_id: number,
      event_name: string,
    }
  }> => {

    const data = {
      event_description: formData.event_description,
      activity: formData.activity,
      event_time: formData.event_time,
      start_date: format(formData.event_date, 'yyyy-MM-dd'),
      end_date: formData.campiagn_timeline ? format(formData.campiagn_timeline, 'yyyy-MM-dd') : format(formData.event_date, 'yyyy-MM-dd'),
    }


    try {
      const response = await axiosReq.post('/api/approval/create-campaign/', data, { signal });
      return response.data;
    } catch (error) {

      captureApiError(error, {
        component: "useCreateCampaignStory",
        url: `${import.meta.env.VITE_API_URL}/api/approval/create-campaign/`,
        httpMethod: "POST",
        apiEndpoint: "/api/approval/create-campaign"
      })

      throw error
    }
  }

  const { mutate: createSocialCampaign, status, data: generatedCampaignStory } = useMutation({
    mutationFn: (formData: CreateThemeType) => {
      const controller = new AbortController()
      return request({ formData, signal: controller.signal })
    },
    onSuccess: (data) => {
      console.log("success");
      queryClient.invalidateQueries({
        queryKey: ["themes"]
      })

      if (data) {
        onGenerate(data.data.event_id)
        posthog.capture('event created', { event_created: data.data.event_id })
      }
    }
  });

  return { createSocialCampaign, status, generatedCampaignStory }
}
